export default {
  apiUrl: '//vimeo.com/api',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vimeo/settings.js